/* eslint-disable */
import { gsap } from 'gsap';

import { CustomEase } from 'gsap/CustomEase';
import { RoughEase, ExpoScaleEase, SlowMo } from 'gsap/EasePack';

import { Flip } from 'gsap/Flip';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Observer } from 'gsap/Observer';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Draggable } from 'gsap/Draggable';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { EaselPlugin } from 'gsap/EaselPlugin';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { TextPlugin } from 'gsap/TextPlugin';


export const animation = (breackpoint) => {

    gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, EaselPlugin, PixiPlugin, TextPlugin, RoughEase, ExpoScaleEase, SlowMo, CustomEase);

    if (!document.body.classList.contains('landing'))
        return true;

    document.documentElement.classList.add('scroll-width-0');
    document.body.classList.add('scroll-width-0');

    const setDocumentHeightObserver = () => {
        const body = document.querySelector('body');
        const observer = new ResizeObserver(() => {
            ScrollTrigger.refresh()
        });

        for (let i = 0; i < body.children.length; i++) {
            observer.observe(body.children[i]);
        }
    }
    setDocumentHeightObserver();


    let currentIndexAll = -1;
    let animatingAll;
    let swipePanelsAll = gsap.utils.toArray("#wrapper section");
    let intentObserverAll = ScrollTrigger.observe({
        type: "wheel,touch",
        onUp: () => !animatingAll && gotoPanelAll(currentIndexAll + 1, true),
        onDown: () => !animatingAll && gotoPanelAll(currentIndexAll - 1, false),
        wheelSpeed: -1,
        tolerance: 10,
        preventDefault: true,
        onPress: self => {
            ScrollTrigger.isTouch && self.event.preventDefault()
        }
    })
    intentObserverAll.disable();
    let preventScrollAll = ScrollTrigger.observe({
        preventDefault: true,
        type: "wheel,scroll",
        allowClicks: true,
        onEnable: self => self.savedScroll = self.scrollX(),
        onChangeY: self => self.scrollX(self.savedScroll)
    });
    preventScrollAll.disable();

    function gotoPanelAll(index, isScrollingDown) {

        // document.body.classList.add('lock-scroll');

        if (!document.body.classList.contains('lock-scroll')) {
            animatingAll = true;
            if (
                (index === (swipePanelsAll.length-1) && isScrollingDown) ||
                (index === -1 && !isScrollingDown)
            ) {
                intentObserverAll.disable();
                preventScrollAll.disable();
                animatingAll = false;
                preventScrollAll.scrollX(preventScrollAll.scrollX() + (index === swipePanelsAll.length ? 1 : -1));
                return;
            }
            let target = isScrollingDown ? swipePanelsAll[index] : swipePanelsAll[currentIndexAll];
            let panelHeight = swipePanelsAll[index].offsetHeight;
            gsap.to(window, {
                duration: 1,
                scrollTo: swipePanelsAll[index],
                onComplete: () => {
                    animatingAll = false;
                }
            })
            currentIndexAll = index;
        }
    }

    let sectionScrollTriger = ScrollTrigger.create({
        trigger: "#wrapper",
        anticipatePin: true,
        onEnter: (self) => {
            if (preventScrollAll.isEnabled === false) {
                self.scroll(self.start);
                preventScrollAll.enable();
                intentObserverAll.enable();
                gotoPanelAll(currentIndexAll + 1, true);
            }
        },
        onEnterBack: (self) => {
            if (preventScrollAll.isEnabled === false) {
                self.scroll(self.start);
                preventScrollAll.enable();
                intentObserverAll.enable();
                gotoPanelAll(currentIndexAll - 1, false);
            }
        }
    });


    let mm = gsap.matchMedia();
    let breakPoint = breackpoint ? breackpoint : 991;
    let desktopBreakPoint = `(min-width: ${breakPoint}px)`;
    let mobileBreakPoint = `(max-width: ${breakPoint - 1}px)`;
    let conditions = {
        isDesktop: desktopBreakPoint,
        isMobile: mobileBreakPoint,
    };


    let enableAnimation = true;
    if (enableAnimation) {
        mm.add(
            conditions,
            (context) => {
                let {isDesktop, isMobile} = context.conditions;

                //section 1
                const heroSection = document.querySelector('.lp-hero');
                const heroAnimateTitle = document.querySelector('.lp-hero_animate_title');
                const heroAnimateTitleBig = document.querySelector('.lp-hero_animate_title_big');
                const bigMan = document.querySelectorAll('.lp-hero__img_animate');

                gsap.set(bigMan, {xPercent: 120})
                gsap.set(heroAnimateTitle, {xPercent: 120})
                gsap.set(heroAnimateTitleBig, {xPercent: -120, opacity: 0})

                const lpHero = gsap.timeline({
                    scrollTrigger: {
                        trigger: heroSection,
                        start: 'top bottom',
                        end: 'bottom top',
                    },
                });

                lpHero.to(heroAnimateTitle, {xPercent: 0, duration: .5, delay: 2}, 0)
                lpHero.to(heroAnimateTitleBig, {opacity: 1, delay: 2.3}, 0)
                lpHero.to(heroAnimateTitleBig, {
                    xPercent: 0,
                    duration: .5,
                    delay: 2.3,
                }, 0)
                lpHero.to(bigMan, {xPercent: 0, duration: .4, delay: 2.8}, 0)


                //section 3
                const lpOurCoreSection = document.querySelector('.lp-our-core-values');
                const lpOurCoreMoveText = document.querySelector('.lp-our-core-values__title');
                const lpOurCoreSubtitle = document.querySelector('.lp-our-core-values__subtitle');
                const lpOurCoreValuesCard = document.querySelectorAll('.lp-our-core-values__card');

                gsap.set(lpOurCoreSubtitle, {opacity: 0})
                gsap.set(lpOurCoreMoveText, {x: 0, left: '100%'})
                gsap.set(lpOurCoreValuesCard, {opacity: 0, y: '30px'})

                //
                // onEnter: () => {
                //     document.body.classList.add('lock-scroll');
                // },
                //     onLeave: () => {
                //     document.body.classList.remove('lock-scroll');
                // },

                const lpOurCore = gsap.timeline({
                    scrollTrigger: {
                        trigger: lpOurCoreSection,
                        start: 'top bottom',
                        end: 'bottom top',
                        toggleActions: "play pause play pause",
                    },
                });


                if (isDesktop) {
                    let w = lpOurCoreMoveText.getBoundingClientRect().width
                    lpOurCore.to(lpOurCoreMoveText, {
                        left: 'auto',
                        x: -w,
                        duration: 8,
                        onEnter: () => {
                            document.body.classList.add('lock-scroll');
                        },
                    }, 0)

                    lpOurCore.to(lpOurCoreSubtitle, {opacity: 1, duration: 2}, '<+=3')

                    lpOurCore.to(lpOurCoreValuesCard, {
                        opacity: 1,
                        duration: 1,
                        delay: .5,
                        y: 0,
                        stagger: {
                            each: 0.5,
                            grid: 'auto',
                            axis: 'y',
                        },
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, '<+=1')

                } else {

                    let w = lpOurCoreMoveText.getBoundingClientRect().width
                    lpOurCore.to(lpOurCoreMoveText, {
                        left: 'auto',
                        x: -w,
                        duration: 4,
                        onEnter: () => {
                            document.body.classList.add('lock-scroll');
                        },
                    }, .3)

                    lpOurCore.to(lpOurCoreSubtitle, {opacity: 1, duration: .5, delay: 2.5}, '<+=.2')

                    lpOurCore.to(lpOurCoreValuesCard, {
                        opacity: 1,
                        duration: .3,
                        delay: .1,
                        y: 0,
                        stagger: {
                            each: 0.2,
                            grid: 'auto',
                            axis: 'y',
                        },
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, '<+=.1')
                }


                const lpCommunitySection = document.querySelector('.lp-community');

                const lpCommunityTitlePart1 = document.querySelector('.lp-community .community__title-part_1');
                const lpCommunityTitlePart2 = document.querySelector('.lp-community .community__title-part_2');

                const lpCommunityDetails = document.querySelector('.lp-community__inner');
                const lpCommunityRightSide = document.querySelectorAll('.lp-community__photos .lp-community__photo-card');

                gsap.set(lpCommunityTitlePart1, {yPercent: 200, opacity: 0})
                gsap.set(lpCommunityTitlePart2, {yPercent: 100, opacity: 0})
                gsap.set(lpCommunityRightSide, {y: '30px', opacity: 0})
                gsap.set(lpCommunityDetails, {yPercent: 100, opacity: 0})


                const lpCommunityTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: lpCommunitySection,
                        start: '10vh bottom',
                        toggleActions: "play pause play pause",
                    },
                });
                if (isDesktop) {
                    lpCommunityTl.to(lpCommunityTitlePart1, {
                        yPercent: 100,
                        opacity: 1,
                        duration: .5,
                        delay: .5,
                        onEnter: () => {
                            document.body.classList.add('lock-scroll');
                        },
                    }, 0)

                    lpCommunityTl.to(lpCommunityTitlePart1, {
                        yPercent: 0,
                        opacity: 1,
                        duration: .5,
                        delay: 1,
                    }, .5)
                    lpCommunityTl.to(lpCommunityTitlePart2, {
                        yPercent: 0,
                        opacity: 1,
                        duration: .5,
                        delay: 1,
                    }, .7)

                    lpCommunityTl.to(lpCommunityTitlePart1, {y: '-150vh', duration: 2.5, delay: 1.5}, 1)
                    lpCommunityTl.to(lpCommunityTitlePart2, {y: '-150vh', duration: 2.5, delay: 1.5}, 1)

                    lpCommunityTl.to(lpCommunityDetails, {yPercent: 0, opacity: 1, duration: 1.5, delay: 1.7}, 1)

                    lpCommunityTl.to(lpCommunityRightSide, {
                        opacity: 1,
                        duration: 1,
                        delay: .5,
                        y: 0,
                        stagger: {
                            from: 'random',
                            amount: 1,
                        },
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, '<+=1')

                } else {

                    lpCommunityTl.to(lpCommunityTitlePart1, {
                        yPercent: 100,
                        opacity: 1,
                        duration: 1,
                        delay: 0.2,
                        onEnter: () => {
                            document.body.classList.add('lock-scroll');
                        },
                    }, 0)

                    lpCommunityTl.to(lpCommunityTitlePart1, {
                        yPercent: 0,
                        opacity: 1,
                        duration: 1.5,
                        delay: 1,
                    }, 0)
                    lpCommunityTl.to(lpCommunityTitlePart2, {
                        yPercent: 0,
                        opacity: 1,
                        duration: 1.5,
                        delay: 1,
                    }, 0)

                    lpCommunityTl.to(lpCommunityTitlePart1, {y: '-150vh', duration: 2, delay: 1.5}, 1.5)
                    lpCommunityTl.to(lpCommunityTitlePart2, {y: '-150vh', duration: 2, delay: 1.5}, 1.5)

                    lpCommunityTl.to(lpCommunityDetails, {yPercent: 0, opacity: 1, duration: 2, delay: 2}, 2)

                    lpCommunityTl.to(lpCommunityRightSide, {
                        opacity: 1,
                        duration: 1,
                        delay: .5,
                        y: 0,
                        stagger: {
                            from: 'random',
                            amount: 1,
                        },
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, '<+=1')
                }

                const lpImpactSection = document.querySelector('.lp-our-impact');
                const lpImpactTitleWrap = document.querySelector('.lp-our-impact .lp-our-impact__title');
                const lpImpactTitlePart1 = document.querySelector('.lp-our-impact .our-impact__title-part_1');
                const lpImpactTitlePart2 = document.querySelector('.lp-our-impact .our-impact__title-part_2');
                const lpImpactTitlePart3 = document.querySelector('.lp-our-impact .our-impact__title-part_3');
                const lpImpactDetails = document.querySelector('.lp-our-impact__inner');

                gsap.set(lpImpactDetails, {y: '100vh', opacity: 0, visibility: 'hidden'})

                gsap.set(lpImpactTitlePart1, {display: 'none', x: '100vh'})
                gsap.set(lpImpactTitlePart2, {display: 'none', x: '100vh'})
                gsap.set(lpImpactTitlePart3, {display: 'none', x: '100vh'})


                const lpImpactTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: lpImpactSection,
                        start: '5% bottom',
                        end: 'bottom top',
                        toggleActions: "play pause play pause"
                    },
                });

                lpImpactTl.to(lpImpactTitlePart1, {
                    display: 'block',
                    x: '',
                    duration: .3,
                    delay: .6,
                    onEnter: () => {
                        document.body.classList.add('lock-scroll');
                    },
                })
                lpImpactTl.to(lpImpactTitlePart1, {display: 'none', x: '-100vh', opacity: 0, duration: .6, delay: .5})

                lpImpactTl.to(lpImpactTitlePart2, {display: 'block', x: '', duration: .3, delay: .4})
                lpImpactTl.to(lpImpactTitlePart2, {display: 'none', x: '-100vh', opacity: 0, duration: .6, delay: .4})

                lpImpactTl.to(lpImpactTitlePart3, {display: 'block', x: '', duration: .3, delay: .4})
                lpImpactTl.to(lpImpactTitlePart3, {display: 'none', x: '-100vh', opacity: 0, duration: .6, delay: .4})

                lpImpactTl.to(lpImpactDetails, {
                    visibility: 'visible',
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    onComplete: function() {
                        document.body.classList.remove('lock-scroll');
                    }
                })


                const lpResearchSection = document.querySelector('.lp-research');

                const lpResearchInner = document.querySelector('.lp-research__inner');
                const lpResearchInnerText = document.querySelector('.lp-research__wrap');
                const lpResearchInnerImg = document.querySelector('.lp-research__photo');

                const lpResearchTitlePart1 = document.querySelector('.lp-research .our-research__title-part_1');
                const lpResearchTitlePart2 = document.querySelector('.lp-research .our-research__title-part_2');
                const lpResearchTitlePart3 = document.querySelector('.lp-research .our-research__title-part_3');

                gsap.set(lpResearchTitlePart1, {
                    yPercent: 300,
                    opacity: 0,
                })
                gsap.set(lpResearchTitlePart2, {yPercent: 300, opacity: 0})
                gsap.set(lpResearchTitlePart3, {yPercent: 300, opacity: 0})

                gsap.set(lpResearchInnerText, {opacity: 0, y: '100vh'})
                if (isDesktop) {
                    gsap.set(lpResearchInnerImg, {
                        x: '100vw',
                    })
                } else {
                    gsap.set(lpResearchInnerImg, {
                        y: '100vw',
                        opacity: 0,
                    })
                }

                const lpResearchTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: lpResearchSection,
                        start: '10% bottom',
                        end: 'bottom top',
                        toggleActions: "play pause play pause"
                    },
                });
                if (isDesktop) {


                    lpResearchTl.to(lpResearchTitlePart1, {
                        yPercent: 200,
                        opacity: 1,
                        delay: .8,
                        onEnter: () => {
                            document.body.classList.add('lock-scroll');
                        },
                    }, .5)

                    lpResearchTl.to(lpResearchTitlePart1, {yPercent: 50, duration: .4, delay: 1}, 2)
                    lpResearchTl.to(lpResearchTitlePart2, {
                        yPercent: 50,
                        duration: .8,
                        opacity: 1,
                        delay: 1.75,
                    }, 2)
                    lpResearchTl.to(lpResearchTitlePart3, {yPercent: 80, duration: .4, delay: 1.2}, 2)

                    lpResearchTl.to(lpResearchTitlePart1, {yPercent: -50, duration: .4, delay: 2.2}, 2)
                    lpResearchTl.to(lpResearchTitlePart2, {yPercent: -50, duration: .4, delay: 2.2}, 2)
                    lpResearchTl.to(lpResearchTitlePart3, {
                        yPercent: -50,
                        duration: .8,
                        opacity: 1,
                        delay: 2.2,
                    }, 2)


                    lpResearchTl.to(lpResearchTitlePart1, {
                        y: '-150vh',
                        duration: 2,
                        opacity: 0,
                        delay: 2.75,
                    }, 2.2)
                    lpResearchTl.to(lpResearchTitlePart2, {
                        y: '-150vh',
                        duration: 2,
                        opacity: 0,
                        delay: 2.75,
                    }, 2.2)
                    lpResearchTl.to(lpResearchTitlePart3, {
                        y: '-150vh',
                        duration: 2,
                        opacity: 0,
                        delay: 2.75,
                    }, 2.2)


                    lpResearchTl.to(lpResearchInnerText, {y: '0', opacity: 1, duration: 1.8, delay: 2}, 3)
                    lpResearchTl.to(lpResearchInnerImg, {
                        x: '0',
                        duration: 2,
                        delay: 2,
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, 3)

                } else {

                    lpResearchTl.to(lpResearchTitlePart1, {yPercent: 200, opacity: 1, delay: .8}, .5)

                    lpResearchTl.to(lpResearchTitlePart1, {yPercent: 50, duration: .8, delay: .8}, 1.5)
                    lpResearchTl.to(lpResearchTitlePart2, {yPercent: 50, duration: .8, opacity: 1, delay: 1}, 1.5)
                    lpResearchTl.to(lpResearchTitlePart3, {yPercent: 80, duration: .8, delay: 1.4}, 1.5)

                    lpResearchTl.to(lpResearchTitlePart1, {yPercent: -50, duration: .8, delay: 1.75}, 1.5)
                    lpResearchTl.to(lpResearchTitlePart2, {yPercent: -50, duration: .8, delay: 1.75}, 1.5)
                    lpResearchTl.to(lpResearchTitlePart3, {yPercent: -50, duration: .8, opacity: 1, delay: 1.75}, 1.5)

                    lpResearchTl.to(lpResearchTitlePart1, {y: '-150vh', duration: 3, opacity: 0, delay: 2}, 2)
                    lpResearchTl.to(lpResearchTitlePart2, {y: '-150vh', duration: 3, opacity: 0, delay: 2}, 2)
                    lpResearchTl.to(lpResearchTitlePart3, {y: '-150vh', duration: 3, opacity: 0, delay: 2}, 2)

                    lpResearchTl.to(lpResearchInnerText, {y: '0', opacity: 1, duration: 1.5, delay: 3}, 1.8)
                    lpResearchTl.to(lpResearchInnerImg, {
                        y: '0',
                        opacity: 1,
                        duration: 1.2,
                        delay: 3,
                        onComplete: function() {
                            document.body.classList.remove('lock-scroll');
                        }
                    }, 1.6)
                }
            });
    }
}

export default animation
